export default "__VITE_ASSET__DR4oy5EG__"